import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Process from "@/components/Process";
import Stats from "@/components/Stats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import ServiceDetail from "@/pages/ServiceDetail";
import WhatsAppFab from "@/components/WhatsAppFab";
import CookieBanner from "@/components/CookieBanner";
import { CookieConsentProvider } from "@/context/CookieConsentContext";
import { useSeo } from "@/hooks/useSeo";

const HOME_SEO = {
  title: "Hype Hafen – Social Media Agentur Hamburg | Content, Strategie, Websites",
  description:
    "Social Media Agentur aus Hamburg. Wir machen Marken unübersehbar – Content Creation, Strategie und Web-Entwicklung aus einer Hand. Kostenloses Erstgespräch, flexible Preise.",
};

const Home = () => {
  const { hash } = useLocation();
  useSeo(HOME_SEO);

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    const id = hash.replace("#", "");
    // Wait a tick for sections to render, then scroll with navbar offset
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }, 80);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div className="App font-body bg-white text-[#2E2E2E]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Stats />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <CookieConsentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen/:slug" element={<ServiceDetail />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <WhatsAppFab />
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: { fontFamily: "Poppins, sans-serif" },
        }}
      />
    </CookieConsentProvider>
  );
}

export default App;
